export default class DtoCentralRangeItem {
    constructor(obj) {
        this.id = obj.centralId
        this.centralId = obj.centralId
        this.day = obj.day
        this.range = obj.range
        this.comment = obj.comment
        this.headers = ['day', 'range', 'comment']
    }
}